import { render, staticRenderFns } from "./StudentListItem.vue?vue&type=template&id=af4a4de0&scoped=true&"
import script from "./StudentListItem.vue?vue&type=script&lang=ts&"
export * from "./StudentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./StudentListItem.vue?vue&type=style&index=0&id=af4a4de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4a4de0",
  null
  
)

export default component.exports